<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">USOS DE CFDI</h1>
      <p class="text-gray-600 dark:text-gray-400">CATÁLOGO DE USOS DE CFDI</p>
    </div>

    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">LISTA</h2>
        <button @click="openModal()" class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 text-sm font-semibold transition">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
          NUEVO
        </button>
      </div>

      <div class="p-6">
        <div v-if="error" class="text-red-500 text-center mb-4">{{ error }}</div>
        <div v-if="loading" class="text-center text-gray-400 py-8">CARGANDO...</div>
        <table v-else class="w-full text-sm text-left">
          <thead class="text-xs uppercase bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 border-b-2 border-gray-200 dark:border-gray-700">
            <tr>
              <th class="px-4 py-2 font-bold">CLAVE</th>
              <th class="px-4 py-2 font-bold">DESCRIPCIÓN</th>
              <th class="px-4 py-2 font-bold">ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id" class="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
              <td class="px-4 py-2 font-mono font-bold text-gray-800 dark:text-gray-200">{{ item.clave }}</td>
              <td class="px-4 py-2 uppercase text-gray-700 dark:text-gray-300">{{ item.descripcion }}</td>
              <td class="px-4 py-2">
                <div class="flex gap-2">
                  <button @click="openModal(item)" class="text-blue-600 hover:text-blue-800 dark:text-blue-400">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
                  </button>
                  <button @click="eliminar(item)" class="text-red-600 hover:text-red-800 dark:text-red-400">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
                  </button>
                </div>
              </td>
            </tr>
            <tr v-if="items.length === 0">
              <td colspan="3" class="px-4 py-8 text-center text-gray-400">SIN REGISTROS</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md">
        <div class="flex justify-between items-center mb-4">
          <h3 class="text-lg font-bold text-gray-900 dark:text-white">{{ editing ? 'EDITAR' : 'NUEVO' }} USO DE CFDI</h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-600"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg></button>
        </div>
        <form @submit.prevent="submit">
          <div class="space-y-4">
            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">CLAVE <span class="text-red-500">*</span></label>
              <input v-model="form.clave" type="text" required maxlength="3"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-violet-500 focus:border-violet-500 uppercase" />
            </div>
            <div>
              <label class="block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase mb-1">DESCRIPCIÓN <span class="text-red-500">*</span></label>
              <input v-model="form.descripcion" type="text" required maxlength="70"
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-violet-500 focus:border-violet-500 uppercase" />
            </div>
          </div>
          <div class="flex justify-end gap-3 mt-6">
            <button type="button" @click="closeModal" class="px-4 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">CANCELAR</button>
            <button type="submit" :disabled="saving" class="px-4 py-2 text-sm text-white bg-violet-600 rounded-md hover:bg-violet-700 disabled:opacity-50">{{ saving ? 'GUARDANDO...' : 'GUARDAR' }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useHttp } from '@/composables/useHttp.js'
import Swal from 'sweetalert2'

const http = useHttp()
const items = ref([])
const loading = ref(false)
const saving = ref(false)
const error = ref('')
const showModal = ref(false)
const editing = ref(null)
const form = ref({ clave: '', descripcion: '' })

const cargar = async () => {
  loading.value = true
  try {
    await http.get('/usos-cfdi')
    items.value = http.data.value ?? []
  } catch { error.value = 'ERROR AL CARGAR' } finally { loading.value = false }
}

const openModal = (item = null) => {
  editing.value = item
  form.value = item ? { clave: item.clave, descripcion: item.descripcion } : { clave: '', descripcion: '' }
  showModal.value = true
}

const closeModal = () => { showModal.value = false; editing.value = null }

const submit = async () => {
  saving.value = true
  try {
    if (editing.value) {
      await http.put(`/usos-cfdi/${editing.value.id}`, form.value)
    } else {
      await http.post('/usos-cfdi', form.value)
    }
    closeModal()
    cargar()
  } catch (err) {
    Swal.fire('Error', err.response?.data?.message || 'Error al guardar', 'error')
  } finally { saving.value = false }
}

const eliminar = async (item) => {
  const r = await Swal.fire({ title: '¿ELIMINAR?', text: `${item.clave} — ${item.descripcion}`, icon: 'warning', showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: 'SÍ, ELIMINAR', cancelButtonText: 'CANCELAR' })
  if (r.isConfirmed) {
    try {
      await http.del(`/usos-cfdi/${item.id}`)
      cargar()
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Error al eliminar', 'error')
    }
  }
}

onMounted(cargar)
</script>
